var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuenta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.867,
    height: 52,
    viewBox: "0 0 52.867 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 52.867,
    height: 52,
    transform: "translate(0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M36.885,29.786a17.88,17.88,0,0,1-2.359,1.458A24.339,24.339,0,0,1,50.685,51.992H52.91A26.553,26.553,0,0,0,36.885,29.786M0,51.992H2.219A24.344,24.344,0,0,1,18.383,31.244a17.88,17.88,0,0,1-2.359-1.458A26.553,26.553,0,0,0,0,51.992m41.939-36.5A15.484,15.484,0,1,0,26.455,30.968,15.488,15.488,0,0,0,41.939,15.49M26.455,28.76A13.276,13.276,0,1,1,39.731,15.484,13.276,13.276,0,0,1,26.455,28.76",
    transform: "translate(-0.043)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuenta);
export default __webpack_public_path__ + "static/media/cuenta.52f46d9cbc1aee2ead8e584d1e195c1d.svg";
export { ForwardRef as ReactComponent };